import { useMemo, useState } from "react";
import { ChevronRight } from "lucide-react";
import { StatusBadge, Empty } from "@/components/common";
import { fmtDate } from "@/lib/api";

const Node = ({ m, kids, depth }) => {
  const [open, setOpen] = useState(depth < 1);
  const children = kids[m.user_id] || [];
  return (
    <li className="relative">
      <div className="flex items-center gap-3 rounded-lg border border-[#1F293D] bg-[#0B0F17] px-3 py-2.5 transition-colors hover:border-emerald-500/40" data-testid={`tree-node-${m.referral_code}`}>
        <button onClick={() => setOpen(!open)} disabled={!children.length} data-testid={`tree-toggle-${m.referral_code}`} className="text-slate-500 disabled:opacity-20">
          <ChevronRight className={`h-4 w-4 transition-transform ${open ? "rotate-90" : ""}`} />
        </button>
        <div className="grid h-8 w-8 place-items-center rounded-full bg-emerald-500/10 font-display text-sm font-bold text-emerald-400">{m.name?.[0]?.toUpperCase()}</div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-white">{m.name}</p>
          <p className="font-mono text-[11px] text-slate-500">{m.referral_code} · L{m.level} · {children.length} direct · joined {fmtDate(m.created_at)}</p>
        </div>
        <StatusBadge status={m.status} />
      </div>
      {open && children.length > 0 && (
        <ul className="ml-6 mt-2 space-y-2 border-l border-dashed border-[#1F293D] pl-4">
          {children.map((c) => <Node key={c.user_id} m={c} kids={kids} depth={depth + 1} />)}
        </ul>
      )}
    </li>
  );
};

export const TeamTree = ({ root, members }) => {
  const kids = useMemo(() => members.reduce((a, m) => ((a[m.sponsor_id] ||= []).push(m), a), {}), [members]);
  const top = kids[root] || [];
  if (!top.length) return <Empty testId="team-empty" text="No team members yet. Share your referral link to grow your network." />;
  return <ul className="space-y-2" data-testid="team-tree">{top.map((m) => <Node key={m.user_id} m={m} kids={kids} depth={0} />)}</ul>;
};
